<template>
  <base-card>
    <template v-slot:header>
      <base-card-heading>Supporting Documents</base-card-heading>
      <base-button modal="#addSupportingDocument" primary small>Add Document</base-button>
    </template>
    <div class="row">
      <div class="col-sm-6">
        <p>Please upload any supporting documents such as:</p>
        <ul>
          <li>Plans</li>
          <li>Planning Documents</li>
          <li>Marketing Documents</li>
          <li>Photographs</li>
          <li>CGIs</li>
        </ul>
      </div>
      <div class="col-sm-6">
        <template v-if="documents.length">
          <base-table small>
            <thead>
              <tr>
                <th colspan="2">Uploaded Documents</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(document, key) in documents" :key="key">
                <td>
                  <a :href="`${base}?bucket=${document.bucket}&uuid=${document.uuid}`" target="_blank">
                    {{ document.caption }}
                  </a>
                </td>
                <td class="text-right">
                  <base-button v-if="!noDelete" small @click="remove(document)">
                    Remove
                  </base-button>
                </td>
              </tr>
            </tbody>
          </base-table>
        </template>
        <template v-else>
          <div class="d-flex align-items-center justify-content-center h-100">
            <p>No documents added</p>
          </div>
        </template>
      </div>
    </div>
  </base-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  created () {
    this.documents = this.$_.cloneDeep(this.supportingDocuments)
  },

  data: () => ({
    documents: []
  }),

  name: 'SupportingDocuments',

  props: {
    noDelete: Boolean
  },

  computed: {
    ...mapGetters({
      base: 'core/storage/base',
      supportingDocuments: 'core/projects/supportingDocuments'
    })
  },

  methods: {
    async remove (document) {
      await this.$dialog.confirm('Are you sure you want to remove this document?', async () => {
        await this.$store.dispatch('core/projects/documents/pull', document)

        this.$flash.success('Document successfully removed.')
      })
    }
  },

  watch: {
    supportingDocuments: {
      deep: true,
      handler () {
        this.documents = this.$_.cloneDeep(this.supportingDocuments)
      }
    }
  }
}
</script>
